import React from "react";
import AudioPlayer from "../AudioPlayer";
import { Wrapper, InfoWrapper, Content, StyledImage } from "./style";
import { Loader } from "../../style/shared";

const WindermereHeaderSection = ({ content }) => (
  <Wrapper>
    <InfoWrapper>
      <AudioPlayer
        fixed={false}
        streamUrl={"/audio/the_night_song.m4a"}
        trackTitle={"'The Night Song'"}
      />
      <Content>
        {content()}
        <div className="windermere">
          <h2>The new album 'Windermere' is out now:</h2>
          <ul>
            <li>
              <a
                href="https://nausicaa-music.bandcamp.com/album/windermere"
                target="_blank"
              >
                Bandcamp
              </a>
            </li>
            <li>
              <a
                href="https://geo.music.apple.com/au/album/windermere/1719609340?itsct=music_box_badge&amp;itscg=30200&amp;app=music&amp;ls=1"
                target="_blank"
              >
                Apple Music
              </a>
            </li>
            <li>
              <a
                href="https://open.spotify.com/album/1s6hd4jaKW7FoWjufflHeB?si=GtXkCOgHSNGKFuJfuARQPw"
                target="_blank"
              >
                Spotify
              </a>
            </li>
          </ul>

          <div>
            Follow on{" "}
            <a href="https://www.facebook.com/nausicaamusic/" target="_blank">
              Facebook
            </a>{" "}
            for updates
          </div>
        </div>
      </Content>
    </InfoWrapper>
    <StyledImage
      src="/images/windermere-bg/windermere-bg.jpg"
      alt="Background Image"
      loader={({ isLoaded }) => <Loader isLoaded={isLoaded} />}
      sources={[
        {
          srcset: [
            "/images/windermere-bg/windermere-bg.jpg 1x",
            "/images/windermere-bg/windermere-bg@2x.jpg 2x",
          ],
        },
      ]}
    />
  </Wrapper>
);

export default WindermereHeaderSection;



// WEBPACK FOOTER //
// ./src/components/WindermereHeaderSection/index.js